<template>
  <div>
    <h1 :class="[this.className, { 'fw-bold': this.bold }]" :style="{ color: this.color }" v-if="this.type === 'h1'">
      <slot />
    </h1>
    <h2 :class="[this.className, { 'fw-bold': this.bold }]" :style="{ color: this.color }" v-if="this.type === 'h2'">
      <slot />
    </h2>
    <h3 :class="[this.className, { 'fw-bold': this.bold }]" :style="{ color: this.color }" v-if="this.type === 'h3'">
      <slot />
    </h3>
    <h4 :class="[this.className, { 'fw-bold': this.bold }]" :style="{ color: this.color }" v-if="this.type === 'h4'">
      <slot />
    </h4>
    <h5 :class="[this.className, { 'fw-bold': this.bold }]" :style="{ color: this.color }" v-if="this.type === 'h5'">
      <slot />
    </h5>
  </div>
</template>

<script>
export default {
  name: 'K2Heading',
  props: ['type', 'color', 'bold', 'className'],
}
</script>
